<template>
  <div class="product-table">
    <div>
      <h2 style="font-weight:bold" v-html="table.title">
      </h2>
      <h3 style="margin-top: 0">
        WKN:{{ table.config.wkn }} | ISIN: {{ table.config.isin }}
      </h3>
    </div>
    <table>
      <thead>
      <tr>
        <th style="width:20%"></th>
        <th style="width:40%">positiv</th>
        <th style="width:40%">negativ</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row,key) in table.data">
        <td>
          {{ row.positive[0].label }}
        </td>
        <td>
          <template v-for="(entry, entryKey) in row.positive">
            {{ entry.timestamp && entry.values.length !== 0 ? getTimeStamp(entry.timestamp) + ' | ' : '' }} {{ entry.values.length > 0 ? entry.values.join(', ') : '—' }}

            <br>
          </template>
        </td>
        <td>
          <template v-for="(entry, entryKey) in row.negative">
            {{ entry.timestamp && entry.values.length !== 0 ? getTimeStamp(entry.timestamp) + ' | ' : '' }} {{ entry.values.length > 0 ? entry.values.join(', ') : '—' }}
            <br>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  Table,
} from "../../model/table/Table"
import Pagebreak
  from "../block/BlockPagebreak.vue"

export default {
  name: 'TmcListTable',
  components: {Pagebreak},
  props: {
    table: {
      type: Table,
      required: true,
    },
  },
  methods: {
    getTimeStamp(timeString) {
      return 'Stand ' + new Date(timeString).toLocaleDateString('de-DE', {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// TmcListTable.vue?5b017b7b